import React, { useContext, useEffect, useCallback, useRef } from "react";
// create intervention context
import { CreateContext } from "interventions/createProvider";
import { ParcellesContext } from "parcelles/provider";
// global context
import { DataContext } from "store/DataProvider";
// router
import { withRouter } from "react-router-dom";
// API HTTP Client
// [DÉSACTIVÉ 2026-04-11 — vue Catalogue] réactiver cet import pour loadOptions
// import { API } from "api/api";
// custom components
import { FormDoubleInputs, FormSemis } from "interventions/forms.js";
// react-bootstrap components
import {
  Card,
  // [DÉSACTIVÉ 2026-04-11 — vue Catalogue] réactiver ButtonToolbar / ToggleButtonGroup / ToggleButton
  // ButtonToolbar,
  // ToggleButtonGroup,
  // ToggleButton,
  Form,
  Button,
} from "react-bootstrap";
// react-select component
import Select from "react-select";
// [DÉSACTIVÉ 2026-04-11 — vue Catalogue] réactiver cet import pour l'AsyncSelect du catalogue
// import AsyncSelect from "react-select/async";
import { formatGroupLabel, colourStyles } from "styles/react-select";
// intervention datas
import { getCategories, getCategorie } from "interventions/datas.js";

const Produits = ({ history, isEditable }) => {
  const {
    listeProduits,
    categorieProduitsId,
    categorieProduits,
    intervention,
    typeId,
    updateCategory,
    filtrerProduits,
    updateList,
    updateItem,
    getQuantityPerSurface,
    getQuantityGrainesPerSurface,
  } = useContext(CreateContext);
  const { parcellesActives, getSurfaceTotale } = useContext(ParcellesContext);
  const { sendRequest, exploitations, parametres } = useContext(DataContext);
  const isMultiExploitations = exploitations.length > 1;
  const categories = getCategories(listeProduits, typeId);
  const categorie = getCategorie(
    listeProduits,
    typeId,
    categorieProduitsId,
    isMultiExploitations,
    parametres.stockPrestataire
  );
  const { produits } = intervention;
  // ============================================================
  // DÉSACTIVÉ 2026-04-11 — onglets "Ma liste" / "Catalogue" / "Création produit"
  // La vue "Catalogue" n'a jamais été déployée en production et générait
  // des erreurs côté API autocomplete. On masque l'intégralité des onglets
  // et on affiche uniquement la vue "Ma liste" (seule utilisée en pratique),
  // renommée sans mention de "liste" côté UI puisqu'il n'y a plus qu'une
  // seule source. Un lien discret "Produit absent ? Créer un produit"
  // remplace l'ancien onglet "Création produit".
  //
  // NB : la logique métier dans createProvider.js (filtrerProduits, flag
  // .catalogue, updateList("produitsManquants", ...)) est INTOUCHÉE pour
  // préserver les éventuels produits catalogue legacy déjà enregistrés.
  //
  // Pour réactiver la vue Catalogue :
  //   1. Décommenter ci-dessous le state `vueProduits` + `handleRadioChange`
  //   2. Décommenter la fonction `loadOptions` plus bas
  //   3. Décommenter les imports en haut du fichier :
  //      `API`, `AsyncSelect`, `ButtonToolbar`, `ToggleButtonGroup`, `ToggleButton`
  //      (et remettre `useState` dans l'import React)
  //   4. Dans le return : décommenter le <ButtonToolbar> des onglets,
  //      remettre la condition `{vueProduits === 1 && (...)}` autour du
  //      bloc "Ma liste", décommenter le bloc `{vueProduits === 2 && (...)}`
  //   5. Supprimer le lien "Produit absent ? Créer un produit"
  //   6. (optionnel) Remettre les placeholders d'origine avec "ma liste"
  // ============================================================
  // const [vueProduits, setVueProduits] = useState(1);

  // Utiliser useRef pour accéder à l'intervention sans déclencher de re-render
  // Cela évite que la requête de conformité phyto soit envoyée lors de la modification de la fiche de chantier
  const interventionRef = useRef(intervention);
  useEffect(() => {
    interventionRef.current = intervention;
  }, [intervention]);

  const testConformitePhyto = useCallback(async () => {
    // uniquement pour les interventions de type traitement phyto
    if (typeId === 60) {
      const produitsConformitePhyto = await sendRequest("conformitePhyto", {
        data: { ...interventionRef.current, parcelles: parcellesActives },
      });
      // deep copy des produits
      let produitsIntervention = JSON.parse(
        JSON.stringify(interventionRef.current.produits)
      );
      // le serveur renvoi souvent un message d'erreur php ...
      if (Array.isArray(produitsConformitePhyto)) {
        // pour chaque produit de l'intervention
        produitsIntervention.forEach((produit) => {
          // trouver le produit renvoyé par le serveur
          let produitConformitePhyto = produitsConformitePhyto.find(
            (p) => p.id === produit.id
          );
          // si trouvé ...
          if (produitConformitePhyto) {
            // ajouter les props de conformité (dosage / mélange)
            produit.statut = produitConformitePhyto.statut;
            produit.messages = produitConformitePhyto.messages;
          }
        });
        const produitsListe = produitsIntervention.filter((p) => !p.catalogue);
        const produitsCatalogue = produitsIntervention.filter(
          (p) => p.catalogue
        );
        // mettre à jour les produits de l'intervention avec ces nouvelles props
        updateList("produits", produitsListe);
        updateList("produitsManquants", produitsCatalogue);
      }
    }
  }, [parcellesActives, sendRequest, typeId, updateList]);

  // au montage du composant et quand les produits/parcelles changent
  useEffect(() => {
    if (produits.length > 0) {
      testConformitePhyto();
    }
  }, [produits.length, parcellesActives, testConformitePhyto]);
  // [DÉSACTIVÉ 2026-04-11 — vue Catalogue] handler des onglets (cf. bloc doc plus haut)
  // const handleRadioChange = (value) => {
  //   if (value !== 3) {
  //     setVueProduits(value);
  //   } else {
  //     history.push("/parametres", { tab: "produit" });
  //   }
  // };
  // [DÉSACTIVÉ 2026-04-11 — vue Catalogue] autocomplete serveur utilisé uniquement par l'AsyncSelect
  // const loadOptions = async (inputValue) => {
  //   if (inputValue.length >= 3) {
  //     try {
  //       let data = await API("autocomplete", {
  //         listName: "produits",
  //         typeId,
  //         inputValue,
  //       });
  //       // rajouter les propriétés
  //       data.forEach((option) => {
  //         // tous les produits ont un champ quantité
  //         option.quantite = "";
  //         // tous les produits qui n'appartiennent pas à la catégorie "traitement de semence" ont un champ quantité surfacique
  //         if (option.idprg !== 6) {
  //           option.quantitePerSurface = "";
  //         }
  //         // les produits de type variété ont un champ "type de semence" et "pmg"
  //         if (option.variete) {
  //           option.typeSemence = 1;
  //           option.pmg = "";
  //         }
  //         if (isMultiExploitations) {
  //           option.origineStock = parametres.stockPrestataire ? 1 : 2;
  //         } else {
  //           option.origineStock = 2;
  //         }
  //       });
  //       return data;
  //     } catch (error) {
  //       console.error(error);
  //       return [];
  //     }
  //   } else {
  //     return [];
  //   }
  // };

  return (
    <Card.Body>
      {/* [DÉSACTIVÉ 2026-04-11 — onglets Ma liste / Catalogue / Création produit]
          Pour réactiver : décommenter ce <ButtonToolbar>, remettre la condition
          `{vueProduits === 1 && (...)}` autour du bloc ci-dessous, décommenter
          le bloc `{vueProduits === 2 && (...)}` et supprimer le lien
          "Produit absent ? Créer un produit" plus bas. Voir le bloc doc en tête
          de composant pour la liste complète des imports à réactiver.
      <ButtonToolbar className="mb-2">
        <ToggleButtonGroup
          type="radio"
          name="vueProduits"
          defaultValue={vueProduits}
          onChange={handleRadioChange}
        >
          <ToggleButton value={1} variant="light">
            Ma liste
          </ToggleButton>
          <ToggleButton value={2} variant="light">
            Catalogue
          </ToggleButton>
          <ToggleButton value={3} variant="light">
            Création produit
          </ToggleButton>
        </ToggleButtonGroup>
      </ButtonToolbar>
      */}
      <div>
        <Select
          isSearchable={false}
          getOptionValue={(option) => option.id}
          options={categories}
          value={categorieProduits}
          onChange={updateCategory.bind(this, "categorieProduits")}
          className="mb-2"
          styles={colourStyles}
          isDisabled={!isEditable}
        />
        <Select
          isMulti
          placeholder="Saisir un produit"
          getOptionValue={(option) => option.id}
          options={categorie}
          formatGroupLabel={formatGroupLabel}
          value={filtrerProduits("liste")}
          onChange={updateList.bind(this, "produits")}
          className="mb-2"
          styles={colourStyles}
          isDisabled={!isEditable}
        />
      </div>
      <div className="mb-3">
        <small className="text-muted">
          Produit absent ?{" "}
          <Button
            variant="link"
            size="sm"
            className="p-0 align-baseline"
            onClick={() => history.push("/parametres", { tab: "produit" })}
            disabled={!isEditable}
          >
            Créer un produit
          </Button>
        </small>
      </div>
      {/* [DÉSACTIVÉ 2026-04-11 — vue Catalogue]
      {vueProduits === 2 && (
        <div>
          <h6 className="text-muted">
            Tapez au moins 3 lettres pour lancer la recherche
          </h6>
          <AsyncSelect
            isMulti
            placeholder="Saisir un produit du catalogue"
            getOptionValue={(option) => option.id}
            cacheOptions
            defaultOptions={[]}
            loadOptions={loadOptions}
            value={filtrerProduits("catalogue")}
            onChange={updateList.bind(this, "produitsManquants")}
            className="mb-2"
            isDisabled={!isEditable}
          />
        </div>
      )}
      */}
      {produits.length > 0 && (
        <h6 className="mb-4 text-success">
          Vous pouvez ajouter d'autres produits grâce au champ ci-dessus
        </h6>
      )}
      <Form>
        {typeId !== 76 && (
          <FormDoubleInputs
            step={".001"}
            getQuantityPerSurface={getQuantityPerSurface.bind(
              this,
              "produits",
              getSurfaceTotale
            )}
            selectedOptions={produits}
            updateItem={updateItem.bind(this, "produits", getSurfaceTotale)}
            testConformitePhyto={testConformitePhyto}
            isMultiExploitations={isMultiExploitations}
            isEditable={isEditable}
          />
        )}
        {typeId === 76 && (
          <FormSemis
            step={".001"}
            getQuantityPerSurface={getQuantityPerSurface.bind(
              this,
              "produits",
              getSurfaceTotale
            )}
            getQuantityGrainesPerSurface={getQuantityGrainesPerSurface.bind(
              this,
              getSurfaceTotale
            )}
            selectedOptions={produits}
            updateItem={updateItem.bind(this, "produits", getSurfaceTotale)}
            isMultiExploitations={isMultiExploitations}
            isEditable={isEditable}
          />
        )}
      </Form>
    </Card.Body>
  );
};

export default withRouter(Produits);
